import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import Accordion from '../Accordion';
import SchoolDataSimple from '../SchoolDataSimple';
import { withRtl } from '../hoc';
import style from './SchoolInfoAccordionMs.scss';
import messages from '../../locale/messages';
import { SchoolAccordion } from '../SchoolAccordion';
import {customisedIntlFormatMessage} from '../../utils/helpers';
import RatingBlocks from '../SchoolInfoRatingBlocks/SchoolInfoRatingBlocks';

const localMessages = defineMessages({
  overviewTitle: {
    id: 'schoolinfo.overview.title',
    defaultMessage: 'Overview',
    description: 'Overview of school',
  },
  less: {
    id: 'schoolinfo.overview.less',
    defaultMessage: 'Show less',
    description: 'Show less text',
  },
  schoolWebsite: {
    id: 'schoolinfo.schoolWebsite',
    defaultMessage: 'School website',
    description: 'School website',
  },
  schoolEmail: {
    id: 'schoolinfo.schoolEmail',
    defaultMessage: 'School email',
    description: 'School email',
  },
  schoolPhone: {
    id: 'schoolinfo.schoolPhone',
    defaultMessage: 'School phone',
    description: 'School phone',
  },
  schoolAddress: {
    id: 'schoolinfo.schoolAddress',
    defaultMessage: 'School address, opens in new window',
    description: 'School address',
  },
  accordionPerformance: {
    id: 'schoolinfo.accordionPerformance',
    defaultMessage: 'Performance',
    description: 'Accordion label for school performance',
  },
  accordionAcademics: {
    id: 'schoolinfo.accordionAcademics',
    defaultMessage: 'Academics',
    description: 'Accordion label for school Academics',
  },
  accordionActivities: {
    id: 'schoolinfo.accordionActivities',
    defaultMessage: 'Activities',
    description: 'Accordion label for school Activities',
  },
  accordionOtherFeatures: {
    id: 'schoolinfo.accordionOtherFeatures',
    defaultMessage: 'Other Features',
    description: 'Accordion label for school Other Features',
  },
  accordionAffiliatedSchools: {
    id: 'schoolinfo.accordionAffiliatedSchools',
    defaultMessage: 'Affiliated Schools',
    description: 'Accordion label for school Affiliated Schools',
  },
  accordionAccessibility: {
    id: 'schoolinfo.accordionAccessibility',
    defaultMessage: 'Accessibility',
    description: 'Accordion label for school Accessibility',
  },
  accordionAccessibilityMoreInfo: {
    id: 'schoolinfo.accordionAccessibilityMoreInfo',
    defaultMessage: 'Accessibility More Informatiion',
    description: 'Accordion label for Accessibility More Information',
  },
  accordionOpenHouses: {
    id: 'schoolinfo.accordionOpenHouses',
    defaultMessage: 'Open Houses & Information Sessions',
    description: 'Accordion label for school Open Houses & Information Sessions',
  },
  accordionMoreInfo: {
    id: 'schoolinfo.accordionMoreInfo',
    defaultMessage: 'More Info',
    description: 'More Info',
  },
  schoolDataELLPrograms: {
    id: 'schoolinfo.schoolDataELLPrograms',
    defaultMessage: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
    description: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
  },
  schoolDataLangaugeCourses: {
    id: 'schoolinfo.schoolDataLangaugeCourses',
    defaultMessage: 'LANGUAGE COURSES',
    description: 'LANGUAGE COURSES',
  },
  virtualLearning: {
    id: 'schoolinfo.virtualLearning',
    defaultMessage: 'VIRTUAL LEARNING',
    description: 'VIRTUAL LEARNING',
  },
  schoolDataAPCourses: {
    id: 'schoolinfo.schoolDataAPCourses',
    defaultMessage: 'ADVANCED PLACEMENT (AP) COURSES',
    description: 'ADVANCED PLACEMENT (AP) COURSES',
  },
  schoolDataAdvancedCourses: {
    id: 'schoolinfo.schoolDataAdvancedCourses',
    defaultMessage: 'ADVANCED COURSES',
    description: 'ADVANCED COURSES',
  },
  schoolDataDiplomaEndorsements: {
    id: 'schoolinfo.schoolDataDiplomaEndorsements',
    defaultMessage: 'DIPLOMA ENDORSEMENTS',
    description: 'DIPLOMA ENDORSEMENTS',
  },
  schoolDataSports: {
    id: 'schoolinfo.schoolDataSports',
    defaultMessage: 'SCHOOL SPORTS',
    description: 'SCHOOL SPORTS',
  },
  schoolDataSportsCoed: {
    id: 'schoolinfo.schoolDataSportsCoed',
    defaultMessage: 'PSAL SPORTS - COED',
    description: 'PSAL SPORTS - COED',
  },
  schoolDataSportsGirls: {
    id: 'schoolinfo.schoolDataSportsGirls',
    defaultMessage: 'PSAL SPORTS - GIRLS',
    description: 'PSAL SPORTS - GIRLS',
  },
  schoolDataSportsBoys: {
    id: 'schoolinfo.schoolDataSportsBoys',
    defaultMessage: 'PSAL SPORTS - BOYS',
    description: 'PSAL SPORTS - BOYS',
  },
  schoolStatsGraduate: {
    id: 'schoolinfo.schoolStatsGraduate',
    defaultMessage: 'of students graduate in four years',
    description: 'percentage of students of graduate. A percent precedes this string (ie 76%) ',
  },
  schoolStatsEnrollCollege: {
    id: 'schoolinfo.schoolStatsEnrollCollege',
    defaultMessage: 'of students enroll in college or career programs',
    description:
      'percentage of students of enroll in college or career programs. A percent precedes this string (ie 76%) ',
  },
  schoolStatsAttendance: {
    id: 'schoolinfo.schoolStatsAttendance',
    defaultMessage: 'student attendance',
    description: 'percentage of student attendance. A percent precedes this string (ie 76%) ',
  },
  schoolStatsSafetyHallCaf: {
    id: 'schoolinfo.schoolStatsSafetyHallCaf',
    defaultMessage: 'of students feel safe in the hallways and cafeteria',
    description: 'percentage of students who feel safe in the hallways and cafeteria. A percent precedes this string (ie 76%) ',
  },
  schoolStatsSafetyBathLock: {
    id: 'schoolinfo.schoolStatsSafetyBathLock',
    defaultMessage: 'of students feel safe in the bathrooms and locker rooms',
    description: 'percentage of students who feel safe in the bathrooms and locker rooms. A percent precedes this string (ie 76%) ',
  },
  schoolStatsVariety: {
    id: 'schoolinfo.schoolStatsVariety',
    defaultMessage:
      'of students feel that this school offers a wide enough variety of programs, classes, and activities to keep them interested in school',
    description:
      'percentage of student who like the variety the school offers. A percent precedes this string (ie 76%) ',
  },
  schoolStatsCoreCourses: {
    id: 'schoolinfo.schoolStatsCoreCourses',
    defaultMessage: 'of students passed core courses',
    description: 'percentage of students who passed core courses. A percent precedes this string (ie 76%) ',
  },
  schoolStatsStateEla: {
    id: 'schoolinfo.schoolStatsStateEla',
    defaultMessage: 'of students scored at Level 3 or 4 on the State English Test',
    description:
      'percentage of students who of students scored at Level 3 or 4 on the State English Test. ' +
      'A percent precedes this string (ie 76%) ',
  },
  schoolStatsStateMath: {
    id: 'schoolinfo.schoolStatsStateMath',
    defaultMessage: 'of students scored at Level 3 or 4 on the State Math Test',
    description:
      'percentage of students who of students scored at Level 3 or 4 on the State Math Test. ' +
      'A percent precedes this string (ie 76%) ',
  },
  middleSchoolDataSports: {
    id: 'schoolinfo.middleSchoolDataSports',
    defaultMessage: 'CHAMPS SPORTS',
    description: 'CHAMPS SPORTS',
  },
  middleSchoolDataSportsCoed: {
    id: 'schoolinfo.middleSchoolDataSportsCoed',
    defaultMessage: 'CHAMPS SPORTS - COED',
    description: 'CHAMPS SPORTS - COED',
  },
  middleSchoolDataSportsGirls: {
    id: 'schoolinfo.middleSchoolDataSportsGirls',
    defaultMessage: 'CHAMPS SPORTS - GIRLS',
    description: 'CHAMPS SPORTS - GIRLS',
  },
  middleSchoolDataSportsBoys: {
    id: 'schoolinfo.middleSchoolDataSportsBoys',
    defaultMessage: 'CHAMPS SPORTS - BOYS',
    description: 'CHAMPS SPORTS - BOYS',
  },
  middleSchoolAcceleratedClasses: {
    id: 'schoolinfo.middleSchoolAcceleratedClasses',
    defaultMessage: 'ACCELERATED CLASSES',
    description: 'ACCELERATED CLASSES',
  },
  frequentlyAttendedHighSchools: {
    id: 'schoolinfo.frequentlyAttendedHighSchools',
    defaultMessage: 'High schools most frequently attended by students from this school',
    description: 'High schools most frequently attended by students from this school',
  },
  secondaryWebsite: {
    id: 'schoolinfo.secondaryWebsite',
    defaultMessage: 'See the School Quality Snapshot',
    description: 'Text for link to school quality snapshot',
  },
  accordionBAPHelpText: {
    id: 'schoolinfo.accordionBAPHelpText',
    defaultMessage: 'For more details and the most up to date building accessibility information, please view the:',
    description: 'Accordion label for BAP Help Text',
  },
});

class SchoolInfoAccordionMs extends PureComponent {
  static defaultProps = {
    otherFeatures: [],
    affiliatedSchools: [],
    loggedIn: false,
  };
  static propTypes = {
    academics: PropTypes.shape({
      ell: PropTypes.arrayOf(PropTypes.shape({})),
      languageClasses: PropTypes.arrayOf(PropTypes.shape({})),
      apCourses: PropTypes.arrayOf(PropTypes.shape({})),
      diplomaEndorsements: PropTypes.arrayOf(PropTypes.shape({})),
      electivesDescription: PropTypes.string.isRequired,
      opportunities: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    accessibility: PropTypes.string.isRequired,
    accordionAnalyticsClick: PropTypes.func.isRequired,
    activities: PropTypes.shape({
      activities: PropTypes.arrayOf(PropTypes.shape({})),
      sportsBoys: PropTypes.arrayOf(PropTypes.shape({})),
      sportsCoed: PropTypes.arrayOf(PropTypes.shape({})),
      sportsGirls: PropTypes.arrayOf(PropTypes.shape({})),
      sportsDescription: PropTypes.string,
      activitiesDescription: PropTypes.string,
    }).isRequired,
    id: PropTypes.number.isRequired,
    openHouses: PropTypes.string.isRequired,
    performance: PropTypes.shape({
      stateCoreCourses: PropTypes.number,
      statStateMath: PropTypes.number,
      statStateEla: PropTypes.number,
      graduation: PropTypes.number,
      enrollCollegeCareer: PropTypes.number,
      stat_safety_hall_caf: PropTypes.number,
      stat_safety_bath_lock: PropTypes.number,
      attendance: PropTypes.number,
      variety: PropTypes.number,
      frequentlyAttendedHS: PropTypes.shape([]),
    }).isRequired,
    intl: PropTypes.shape().isRequired,
    otherFeatures: PropTypes.arrayOf(PropTypes.shape({})),
    affiliatedSchools: PropTypes.arrayOf(PropTypes.shape({})),
    bapurl: PropTypes.string,
    loggedIn: PropTypes.bool
  };

  getAcademicOpportunities = () => {
    const { academics } = this.props;
    const academicsList = academics.opportunities.map(academicItem => (
      <li key={academicItem.name}>{academicItem.name}</li>
    ));
    return <ul className={style.disc}>{academicsList}</ul>;
  };

  getOtherInfo = (listItems, title) => {
    if (!listItems || listItems.length === 0) {
      return null;
    }

    const itemContents = listItems.map(item => item.name).join(', ');

    return <SchoolDataSimple title={title} stat={itemContents} />;
  };

  getTextInformation = (text, title) => {
    if (text) {
      return <SchoolDataSimple title={title} stat={text} />;
    }
    return null;
  };

  getFrequentlyAttendedHS = (listItems, title) => {
    const { id } = this.props;
    if (listItems && listItems.length > 0) {
      return (
        <div className={style.frequentHSWrapper}>
          <span className={style.frequentHSTitle}>{title}</span>
          <ul className={style.disc}>{listItems.map(item => <li key={`${id}-${item}`}>{item}</li>)}</ul>
        </div>
      );
    }
    return null;
  };

  getOtherFeatures = () => {
    const { accordionAnalyticsClick, otherFeatures, intl } = this.props;
    if (otherFeatures) {
      const otherFeaturesList = otherFeatures.map(item => <li key={item.name}>{item.name}</li>);
      return (
        <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionOtherFeatures)} analytics={accordionAnalyticsClick}>
          <div className={style.schoolDataWrapper}>
            <ul className={style.disc}>{otherFeaturesList}</ul>
          </div>
        </Accordion>
      );
    }
    return false;
  };

  getAffiliatedSchools = () => {
    const { affiliatedSchools } = this.props;
    const affiliatedSchoolsList = affiliatedSchools.map(item => <li key={item}>{item}</li>);
    return <ul className={style.disc}>{affiliatedSchoolsList}</ul>;
  };

  getStatDisplay = (statistic, displayString) => {
    if (!statistic) {
      return null;
    }
    return (
      <li>
        <span className={style.stat}>{statistic}%</span> {displayString}
      </li>
    );
  };

  getBAP = (bapurl) => {
    const { intl } = this.props
    if (bapurl) {
      return (
        <li>
          {customisedIntlFormatMessage(intl, localMessages.accordionBAPHelpText)}{' '}
          <a target="_blank" rel="noopener" href={bapurl}>Building Accessibility Profile</a>
        </li>
      );
    }
    return null
  };

  getAccessibilityMoreInfo = () => {
    const { school } = this.props;
    const { accessibility_more_info } = school;
    if (!accessibility_more_info) {
      return null;
    }
    const AccessibilityTypeList = accessibility_more_info.split(',').map(AccessibilityTypeItem => (
      <li key={AccessibilityTypeItem}>{AccessibilityTypeItem}</li>
    ));
    return <ul className={style.disc}>{AccessibilityTypeList}</ul>;
  };

  /* eslint-disable react/no-danger */
  render() {
    /* add all fields that need to be rendered, 
    otherwise it won't be showing in the school list for an application by default */
    const { accordionAnalyticsClick, performance, intl, school } = this.props;
    const { ell, languageClasses, apCourses, virtualLearning, diplomaEndorsements, electivesDescription, opportunities, artCourses } = this.props.academics;
    const { sportsBoys, sportsGirls, sportsCoed, sportsDescription, activitiesDescription } = this.props.activities;
    const { accessibility, openHouses, bapurl } = this.props;

    const acceleratedClassesMessageCode = localMessages.middleSchoolAcceleratedClasses;
    const sportsCoedMessageCode = localMessages.middleSchoolDataSportsCoed;
    const sportsGirlsMessageCode = localMessages.middleSchoolDataSportsGirls;
    const sportsBoysMessageCode = localMessages.middleSchoolDataSportsBoys;
    const frequentlyAttendedHighSchools = localMessages.frequentlyAttendedHighSchools

    return (
      <div className={style.root}>
        <SchoolAccordion
          {...this.props}
          style={style}
        ></SchoolAccordion>
        {( performance.instructionAndPerformanceRating || performance.safetyAndSchoolClimateRating || performance.relationshipsWithFamiliesRating || performance.stateCoreCourses || performance.statStateEla || performance.statStateMath || performance.graduation || performance.enrollCollegeCareer || performance.attendance || performance.stat_safety_hall_caf || performance.stat_safety_bath_lock || performance.variety || (performance.frequentlyAttendedHS && performance.frequentlyAttendedHS.length>0) || this.props.secondary_website) &&
        <Accordion label={customisedIntlFormatMessage(intl, messages.generalStringPerformance)} analytics={accordionAnalyticsClick}>
          {performance.instructionAndPerformanceRating && (
            <div className={style.ratingRow}>
              <div className={style.ratingLabel}>
                {performance.instructionAndPerformanceLabel}
              </div>
              <div className={style.ratingValueLine}>
                <RatingBlocks
                  score={performance.instructionAndPerformanceRating.score}
                />
                <span className={style.ratingText}>
                  {performance.instructionAndPerformanceRating.label}
                </span>
              </div>
            </div>
          )}
          <div className={style.schoolDataWrapper}>
            <ul>
              {this.getStatDisplay(
                performance.stateCoreCourses,
                customisedIntlFormatMessage(intl, localMessages.schoolStatsCoreCourses),
              )}
              {this.getStatDisplay(performance.statStateEla, customisedIntlFormatMessage(intl, localMessages.schoolStatsStateEla))}
              {this.getStatDisplay(performance.statStateMath, customisedIntlFormatMessage(intl, localMessages.schoolStatsStateMath))}
            </ul>
          </div>
          {performance.safetyAndSchoolClimateRating && (
            <div className={style.ratingRow}>
              <div className={style.ratingLabel}>
                {performance.safetyAndSchoolClimateLabel}
              </div>
              <div className={style.ratingValueLine}>
                <RatingBlocks
                    score={performance.safetyAndSchoolClimateRating.score}
                  />
                <span className={style.ratingText}>
                  {performance.safetyAndSchoolClimateRating.label}
                </span>
              </div>
            </div>
          )}
          <div className={style.schoolDataWrapper}>
            <ul>
              {this.getStatDisplay(performance.attendance, customisedIntlFormatMessage(intl, localMessages.schoolStatsAttendance))}
              {this.getStatDisplay(performance.stat_safety_hall_caf, customisedIntlFormatMessage(intl, localMessages.schoolStatsSafetyHallCaf))}
              {this.getStatDisplay(performance.stat_safety_bath_lock, customisedIntlFormatMessage(intl, localMessages.schoolStatsSafetyBathLock))}
              {this.getStatDisplay(performance.variety, customisedIntlFormatMessage(intl, localMessages.schoolStatsVariety))}
            </ul>
          </div>
          {performance.relationshipsWithFamiliesRating && (
            <div className={style.ratingRow}>
              <div className={style.ratingLabel}>
                {performance.relationshipsWithFamiliesLabel}
              </div>
              <div className={style.ratingValueLine}>
                <RatingBlocks
                    score={performance.relationshipsWithFamiliesRating.score}
                  />
                <span className={style.ratingText}>
                  {performance.relationshipsWithFamiliesRating.label}
                </span>
              </div>
            </div>
            )}
          {this.props.secondary_website && (
              <div className={style.schoolQualitySnapshotRow}>
                <span dangerouslySetInnerHTML={{
                  __html: performance.school_quality_snapshot_html
                }} />
              </div>
            )}
          {this.getFrequentlyAttendedHS(
            performance.frequentlyAttendedHS,
            customisedIntlFormatMessage(intl, frequentlyAttendedHighSchools),
          )}
        </Accordion>}
        {(ell.length > 0 || apCourses.length > 0 || diplomaEndorsements.length > 0 || languageClasses.length > 0 || opportunities.length > 0 || electivesDescription || virtualLearning || (artCourses && artCourses.length > 0)) &&
        <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionAcademics)} analytics={accordionAnalyticsClick}>
          <div className={style.schoolDataWrapper}>
            {this.getAcademicOpportunities()}
            {this.getOtherInfo(ell, customisedIntlFormatMessage(intl, localMessages.schoolDataELLPrograms))}
            {this.getOtherInfo(languageClasses, customisedIntlFormatMessage(intl, localMessages.schoolDataLangaugeCourses))}
            {this.getOtherInfo(apCourses, customisedIntlFormatMessage(intl, acceleratedClassesMessageCode))}
            {this.getTextInformation(electivesDescription, 'Electives')}
            {this.getOtherInfo(artCourses, customisedIntlFormatMessage(intl, messages.artCourses))}
            {this.getOtherInfo(diplomaEndorsements, customisedIntlFormatMessage(intl, localMessages.schoolDataDiplomaEndorsements))}
            {this.getTextInformation(virtualLearning, customisedIntlFormatMessage(intl, localMessages.virtualLearning))}
          </div>
        </Accordion>}
        {(activitiesDescription || sportsDescription || sportsCoed.length > 0 || sportsGirls.length > 0 || sportsBoys.length > 0) &&
        <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionActivities)} analytics={accordionAnalyticsClick}>
          <div className={style.schoolDataWrapper}>
            {this.getTextInformation(activitiesDescription, customisedIntlFormatMessage(intl, localMessages.accordionActivities))}
            {this.getTextInformation(sportsDescription, customisedIntlFormatMessage(intl, localMessages.schoolDataSports))}
            {this.getOtherInfo(sportsCoed, customisedIntlFormatMessage(intl, sportsCoedMessageCode))}
            {this.getOtherInfo(sportsGirls, customisedIntlFormatMessage(intl, sportsGirlsMessageCode))}
            {this.getOtherInfo(sportsBoys, customisedIntlFormatMessage(intl, sportsBoysMessageCode))}
          </div>
        </Accordion>}
        {(accessibility && accessibility.length > 0 || bapurl || school.accessibility_more_info) &&
        <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionAccessibility)} analytics={accordionAnalyticsClick}>
          <div className={style.schoolDataWrapper}>
          <ul>
                <li>{accessibility}</li>
                {this.getBAP(bapurl)}
                {this.getAccessibilityMoreInfo() && (<SchoolDataSimple title={customisedIntlFormatMessage(intl, localMessages.accordionAccessibilityMoreInfo)} stat={this.getAccessibilityMoreInfo()} ></SchoolDataSimple>)}
            </ul>
          </div>
        </Accordion>}
        {openHouses && (
          <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionOpenHouses)} analytics={accordionAnalyticsClick}>
            <div className={style.schoolDataWrapper}>
              <span dangerouslySetInnerHTML={{ __html: openHouses }} />
            </div>
          </Accordion>
        )}
        {(this.props.otherFeatures && this.props.otherFeatures.length > 0) && 
          <div>{this.getOtherFeatures()}</div>
        }
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

export { SchoolInfoAccordionMs };
export default compose(injectIntl, withRtl(style), withStyles(style), connect(mapStateToProps))(SchoolInfoAccordionMs);
